import { useContext } from "react";
import { WplywContext } from "../../../../../../context/wplywContext";

const InnerStage3Checker = (selectedPerson) => {
    const { wplyw } = useContext(WplywContext);
    if (!wplyw?.wplyw_data?.data?.msr_wplywy) return false;

    const data = wplyw.wplyw_data.data.msr_wplywy || {};
    const persons = Array.isArray(data.msr_persons) ? data.msr_persons : [];

    // Find the selected person
    const person = persons.find(
        (p) => p?.msr_persons_id && selectedPerson?.msr_persons_id && p.msr_persons_id === selectedPerson.msr_persons_id
    );
    if (!person || !Array.isArray(person.msr_reckonings)) return false;

    // Totals for payouts/transfers are not needed here; validation uses transfers and reckonings directly.

    // Validation checks for transfers
    const hasInvalidTransfers = Array.isArray(person.msr_transfers)
        ? person.msr_transfers.some((transfer) => {
              if (!transfer) return true; // Check for null/undefined transfer objects

              // Check if amount is valid and greater than 0
              const transferAmount = parseFloat(transfer?.msr_transfers_amount) || 0;
              if (transferAmount <= 0) return true;

              // If it's a bank transfer, validate bank account and account owner
              const transferTypeId = transfer?.msr_transfers_types_id;
              const defaultValues = wplyw?.wplyw_data?.data?.default_values?.msr_transfers_types || [];
              const transferType = defaultValues.find((type) => type?.msr_transfers_types_id === transferTypeId);
              const isBankTransfer = transferType?.msr_transfers_types_bank_transfer === 1;

              if (isBankTransfer) {
                  const accountNumber = (transfer?.msr_transfers_account_number || "").replace(/\s+/g, ""); // Remove spaces
                  const accountOwner = transfer?.msr_transfers_account_owner || "";
                  const isAccountValid = /^\d{26}$/.test(accountNumber); // Basic 26-digit bank account validation
                console.log("Account Number:", accountNumber, "Account Owner:", accountOwner, "Is Valid:", isAccountValid);
                  return !accountNumber || !accountOwner || !isAccountValid;
              }

              return false;
          })
        : true;
          console.log("Has Invalid Transfers:", hasInvalidTransfers);
    return !hasInvalidTransfers && data.msr_wplywy_date_forward && data.msr_wplywy_date_forward != 'null';
};

export default InnerStage3Checker;
